<div
    class="w-full flex flex-row bg-linear-to-r from-sky-700 to-cyan-950 relative"
>
    <div
        class="cursor-pointer flex items-center justify-center py-2 px-4 bg-slate-400/50 hover:bg-sky-700 transition-all duration-300"
        (click)="app.onMenuButtonClick($event)"
    >
        <span class="fa fa-bars text-white text-4xl! aspect-square"></span>
    </div>

    <div
        class="w-full flex sm:flex-row flex-col sm:items-end items-center justify-between px-6 py-1 gap-2"
    >
        <a class="text-white text-3xl font-bold cursor-pointer" href="/">
            toqWEB
        </a>

        <div class="relative flex items-center justify-between gap-4 md:mr-10">
            <div class="flex flex-col gap-1 text-white text-sm">
                <span>{{ usuario }}</span>
                <span>{{ empresa }}</span>
            </div>

            <img
                alt="main logo"
                src="assets/images/user_placeholder.png"
                class="h-12 cursor-pointer rounded-full aspect-square"
                (click)="app.onTopbarMenuButtonClick($event)"
            />

            <ul
                class="-translate-y-1/2 right-0 top-full mt-2 absolute bg-sky-950 text-white p-0.5 opacity-0 pointer-events-none flex flex-col gap-2 sm:w-60 w-50 transition-all duration-300 ease-in z-50"
                [ngClass]="{
                    'opacity-100 translate-y-0 pointer-events-auto!':
                        app.topbarMenuActive,
                }"
            >
                <li
                    #usuarios
                    [ngClass]="{
                        'menuitem-active': app.activeTopbarItem === usuarios,
                    }"
                    class="w-full flex flex-col"
                >
                    <a
                        (click)="app.onTopbarItemClick($event, usuarios)"
                        class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                    >
                        <i class="topbar-icon fa fa-fw fa-user"></i>
                        <span class="topbar-item-name">Usuários</span>
                    </a>

                    <ul
                        class="max-h-0 pointer-events-none ml-[5%] transition-all duration-300 ease-in-out overflow-hidden"
                        [ngClass]="{
                            'max-h-96 pointer-events-auto!':
                                app.activeTopbarItem === usuarios,
                        }"
                    >
                        <li role="menuitem">
                            <a
                                href="#"
                                class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                                (click)="
                                    app.onTopbarSubItemClick($event, '/usuario')
                                "
                            >
                                <i class="fa fa-fw fa-tasks"></i>
                                <span>Usuários</span>
                            </a>
                        </li>

                        <li role="menuitem">
                            <a
                                href="#"
                                class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                                (click)="app.onTopbarSubItemClick($event)"
                            >
                                <i class="fa fa-fw fa-tasks"></i>
                                <span>Perfil</span>
                            </a>
                        </li>

                        <li role="menuitem">
                            <a
                                href="#"
                                class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                                (click)="app.onTopbarSubItemClick($event)"
                            >
                                <i class="fa fa-fw fa-tasks"></i>
                                <span>Permissões</span>
                            </a>
                        </li>

                        <li role="menuitem">
                            <a
                                href="#"
                                (click)="app.alterarSenha()"
                                class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                            >
                                <i class="fa fa-fw fa-tasks"></i>
                                <span>Alterar Senha</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <li role="menuitem">
                    <a
                        href="#"
                        (click)="app.deslogar()"
                        class="cursor-pointer hover:bg-cyan-700 bg-transparent transition-all duration-300 flex items-center gap-1 py-2 px-4"
                    >
                        <i class="fa fa-fw fa-sign-out"></i>
                        <span>Sair</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <app-menu></app-menu>
</div>
